// Libs
import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const usePageStyle = makeStyles((theme: Theme) => ({
    root: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        boxSizing: "border-box",
    },
    ds: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    bare: {
        padding: 0,
        boxSizing: "border-box",
        height: "100%",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    dsWithoutPadding: {
        paddingBottom: theme.spacing(2),
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    hideOverflow: {
        overflowY: "hidden",
    },
    flex: {
        display: "flex",
    },
    fullWidth: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    fullHeight: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}));
